import { graphql } from '@teachino/shared-infrastructure';

export const duplicateTopicsToFolderMutation = graphql(`
  mutation DuplicateTopicsToFolder($topicIds: [String!]!, $folderId: String) {
    duplicateTopics(
      duplicateTopicsInput: { topicIds: $topicIds, targetFolderId: $folderId }
    ) {
      __typename
    }
  }
`);
